import React from 'react';
import { inject, observer } from 'mobx-react';
import ArtworkCard from '../cardHolders/artworksCard'
import ArtistCard from '../cardHolders/artistsCard';
import { Redirect } from 'react-router-dom';
import Button from 'react-bulma-components/lib/components/button';
import Signup from '../Home/onboarding/signup';
var qs = require('qs')
@inject('userStore', 'navigatorStore', 'authStore', 'landingPageArtworksStore', 'artworksStore', 'artistDetails', 'categoryPageArtworksStore')
@observer
export default class LandingPageIntroSection extends React.Component {
    constructor(props) {
        super(props);
        this.state = {}
    }
    handleBrowseArtworkClick() {
        if (!localStorage.hasOwnProperty("userData")) {
            this.props.navigatorStore.openSignInModal()
        } else {
            this.setState({
                wantsToBrowseArtworks: true
            })
        }
    }
    handleSignUpClick() {
        if(localStorage.hasOwnProperty("userData")) {
            this.setState({
                toPFE : true
            })
        }
       else this.props.navigatorStore.openSignUpModal()
    }
    render() {
        if (this.state.toPFE) {
            return (
                <Redirect push to="/platform-for-everyone" />
            )
        }
        if (this.state.wantsToBrowseArtworks) {
            return (
                <Redirect push to="/artworks" />
            )
        }
        return (
            <div className="rectangle-big-and-main">
                <div className="row">
                    <div className="col-md-6">
                        <div className="some-content">
                            <div className="give-your-walls-a-st">
                                Give your walls a story to tell
                </div>
                            <div className="discover-buy-non">
                                <div className="subheading-text">Discover & buy non-digital artworks from
                                    artists and
                        collectors around the globe.</div>
                            </div>
                            <div className="landingpage-buttons">
                                <div>
                                    <Button id="masterpieces-landingpage-primary-button"
                                        className="masterpieces-primary-buttons" onClick={this.handleBrowseArtworkClick.bind(this)}>BROWSE ARTWORKS
                        </Button>
                                </div>
                                <div >
                                    <Button id="masterpieces-landingpage-secondary-button"
                                        className="masterpieces-secondary-buttons" onClick={this.handleSignUpClick.bind(this)}>
                                        {(!localStorage.hasOwnProperty("userData")) ? "JOIN THE PLATFORM" : "PLATFORM FOR EVERYONE"}</Button>
                                </div>

                                <Signup></Signup>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="home-images">
                            <img alt="" src={require('../../assets/home_images.png')}></img>
                        </div>
                    </div>
                </div>
            </div>

        )
    }
}


// WEBPACK FOOTER //
// ./src/components/sectionHolders/landingPageIntroSection.js